type StatusType = 'success' | 'warning' | 'error' | 'info' | 'neutral';

interface StatusBadgeProps {
  status: StatusType;
  label: string;
}

const statusStyles: Record<StatusType, string> = {
  success: 'bg-green-100 text-green-800',
  warning: 'bg-amber-100 text-amber-800',
  error: 'bg-red-100 text-red-800',
  info: 'bg-blue-100 text-blue-800',
  neutral: 'bg-gray-100 text-gray-800',
};

export function StatusBadge({ status, label }: StatusBadgeProps) {
  return (
    <span
      className={`inline-flex items-center px-2 py-0.5 rounded text-xs font-medium ${statusStyles[status]}`}
    >
      {label}
    </span>
  );
}

// Helpers for common status mappings
export function getDeliveryStatusType(status: string): StatusType {
  switch (status) {
    case 'sent':
      return 'success';
    case 'queued':
      return 'info';
    case 'failed':
      return 'error';
    case 'skipped':
      return 'warning';
    default:
      return 'neutral';
  }
}

export function getPlatformStatusType(platform: string): StatusType {
  switch (platform) {
    case 'ios':
      return 'info';
    case 'android':
      return 'success';
    default:
      return 'neutral';
  }
}
